import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { ProfileQuestionResource } from './ProfileQuestion';
import { AI_ASSISTED_STATUSES } from 'util/AiAssistedStatuses';

/**
 * Relationship classes
 */
export class ProfileQuestionAnswerAttributes {
  id: string = null;
  profileQuestionId: string = null;
  profileQuestionLabel: string = null;
  profileQuestionName: string = null;
  userProfileId: string = null;
  value: string | unknown = null;
  aiAssisted: AI_ASSISTED_STATUSES;
}

export class ProfileQuestionAnswerBelongsTo {
  profileQuestion: () => ProfileQuestionResource = () => new ProfileQuestionResource();
}

export class ProfileQuestionAnswerHasOne {}
export class ProfileQuestionAnswerHasMany {}

/**
 * Utility interfaces
 */
export interface ProfileQuestionAnswerMethods {}

export interface ProfileQuestionAnswerInterface
  extends ProfileQuestionAnswerAttributes,
    ProfileQuestionAnswerBelongsTo,
    ProfileQuestionAnswerType {}

type ProfileQuestionAnswerType = GConstructor<ProfileQuestionAnswerInterface>;

export interface ProfileQuestionAnswerResource
  extends Base<ProfileQuestionAnswerAttributes>,
    ProfileQuestionAnswerInterface,
    ProfileQuestionAnswerMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<ProfileQuestionAnswerAttributes>({
    queryName: 'user_profile/profile_question_answers',
    className: 'ProfileQuestionAnswer',
    AttributesClass: ProfileQuestionAnswerAttributes,
    BelongsToClasses: [
      {
        Klass: ProfileQuestionAnswerBelongsTo,
      },
    ],
  });

export const ProfileQuestionAnswerResourceClass = <TBase extends ProfileQuestionAnswerType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements ProfileQuestionAnswerMethods {};

export class ProfileQuestionAnswerResource extends ClassExtender<ProfileQuestionAnswerInterface>(
  BaseClass,
  ProfileQuestionAnswerResourceClass,
) {}

/**
 * Resource instance
 */
export const ProfileQuestionAnswer = APILibrary.createResource<ProfileQuestionAnswerResource>(
  ProfileQuestionAnswerResource,
);
